import React, { Component } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronDown, faCircle } from '@fortawesome/pro-light-svg-icons';
import { faCircleCheck } from '@fortawesome/pro-solid-svg-icons';
import {
  Typography,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Stack,
  Box,
  Chip,
} from '@mui/material';
import ItemButtons from './ItemButtons';
import { CHECKLIST_YES_INDICATOR } from '../common/constants';
import { getDateTime } from '../common/utils';

class Item extends Component {
  state = {
    isCompleted: false,
  };

  componentDidMount() {
    if (this.props.item?.itemCompletedInd === CHECKLIST_YES_INDICATOR) {
      this.setState({ isCompleted: true });
    }
  }

  render() {
    const code = this.props.item.itemTimeCode;
    return (
      <Accordion
        elevation={0}
        expanded={this.props.isExpand}
        id={code + '_accordion'}
        sx={{ width: '100%' }}
        className="checklistItem"
      >
        <AccordionSummary
          expandIcon={
            <FontAwesomeIcon
              icon={faChevronDown}
              size="lg"
              style={{
                marginLeft: '0.5rem',
                marginRight: '0.5rem',
                marginTop: '0.5rem',
                marginBottom: '0.75rem',
              }}
            />
          }
          id={code + '_accordionSummary'}
          aria-controls={code + '_accordionDetails'}
          sx={{
            mt: 0,
            p: 0.5,
            flexDirection: 'row-reverse',
            flexGrow: 1,
            alignItems: 'flex-start',
          }}
          onClick={() => {
            this.props.toggleItemExpansionStatus(
              this.props.item.itemTimeCode,
              !this.props.isExpand,
            );
          }}
        >
          <Stack
            direction={{
              xs: 'column',
              lg: 'row',
            }}
            justifyContent="space-between"
            sx={{ ml: 0.5, width: '100%' }}
          >
            <Box>
              <Stack direction="row" sx={{ alignItems: 'flex-start' }}>
                {!this.props.item.itemBoxHideInd && (
                  <FontAwesomeIcon
                    id={'checklist__icon_isComplete_' + code}
                    fixedWidth
                    icon={this.state.isCompleted ? faCircleCheck : faCircle}
                    className={this.state.isCompleted ? 'myOdu__good' : ''}
                    style={{
                      // alignSelf: 'center',
                      marginRight: '.25rem',
                      marginTop: '0.25rem',
                    }}
                    size="xl"
                  />
                )}
                <Stack>
                  <Stack direction="row" alignItems="flex-start" spacing={1}>
                    <Typography
                      component="h4"
                      dangerouslySetInnerHTML={{
                        __html: this.props.item.title,
                      }}
                    />
                    {this.props.isNonVerifiable && (
                      <Chip
                        label="Unverifiable"
                        size="small"
                        className="myOdu__chip notTrackedChip"
                      />
                    )}
                  </Stack>
                  {this.props.item.itemBoxHideInd ? (
                    <Typography className="doesNotHaveCheckbox">
                      This item will not display a checkmark when complete.
                    </Typography>
                  ) : (
                    this.state.isCompleted &&
                    this.props.item.itemCompleteDate && (
                      <Typography className="itemMarkedComplete">
                        {`Marked complete ${getDateTime(this.props.item.itemCompleteDate)}`}
                      </Typography>
                    )
                  )}
                </Stack>
              </Stack>
            </Box>
            {this.props.item.itemRequiredInd === CHECKLIST_YES_INDICATOR ? (
              <Typography className="myOdu__required" sx={{ mr: 1 }}>
                Required
              </Typography>
            ) : (
              <Typography className="myOdu__optional" sx={{ mr: 1 }}>
                Optional
              </Typography>
            )}
          </Stack>
        </AccordionSummary>
        <AccordionDetails id={code + '_accordionDetails'}>
          <Stack direction="column">
            <Typography
              component="p"
              dangerouslySetInnerHTML={{
                __html: this.props.item.description,
              }}
            />
            <ItemButtons item={this.props.item} />
          </Stack>
        </AccordionDetails>
      </Accordion>
    );
  }
}

export default Item;
